export function createFormData(data) {
    const formData = new FormData();
    
    Object.keys(data).forEach((key) => {
        const value = data[key];

        if (value === null || value === undefined) {
            return;
        } else if (value instanceof File) {
            formData.append(key, value);
        } else if (Array.isArray(value)) {
            value.forEach((item) => {
                formData.append(`${key}[]`, item);
            });
        } else if (typeof value === 'object') {
            formData.append(key, JSON.stringify(value)); 
        } else {
            formData.append(key, value);
        }
    });

    return formData;
}

export function formatFieldName(field) {
    return field
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase());
}

export function phoneNumberOnly(e) {
    if (e.key !== '+' && !/[0-9]/.test(e.key)) {
        e.preventDefault();
    }
}

export function numbersOnly(e) {
    if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
    }
}

export function handlePaste(e) {
    e.preventDefault();
    const text = e.clipboardData?.getData('text') ?? '';
    if (/^[0-9+]+$/.test(text)) {
        e.target.value = text;
    }
}

export function handleNumberPaste(e) {
    e.preventDefault();
    const text = e.clipboardData?.getData('text') ?? '';
    if (/^[0-9]+$/.test(text)) {
        e.target.value = text;
    }
}

export function extractExtension(files) {
    var extensions; 
    if(files instanceof Array) {
        extensions = files.join(',');
    }
    else {
        extensions = files.split(",");
    }
    return extensions.map((type) => type.split('/')[1]);
}

export function extractExtensionInString(types) {
    const extensions = extractExtension(types);
    return extensions.join(', ');
}

export const formatFileSize = (size) => {
    if (!size) return "0 B";
    if (size < 1000) return `${size} B`;
    if (size < 1e6) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / 1e6).toFixed(2)} MB`;
  };

export function trimEmailField(value, handleChange) {
  if (value && typeof value === 'string') {
    const trimmedValue = value.trim();
    if (trimmedValue !== value) {
      handleChange(trimmedValue);
    }
  }
}